import React from 'react';
import { tomos } from '../data/landing';
export function TomosSection() {
  return <section id="contenido" className="w-full bg-ink py-20 lg:py-24" data-id="element-163" data-mp="1kclotu9tpl1p">
      <div className="mx-auto max-w-content px-6" data-id="element-164" data-mp="1kaqz82nlx4ra">
        <div className="max-w-2xl" data-id="element-165" data-mp="1p4lgz0jnj9nq">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.18em] text-sunset" data-id="element-166" data-mp="1p4byrz4um6sl">
            El contenido
          </p>
          <h2 className="font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-167" data-mp="xcnrhr0xgagm">
            Un mapa completo para tu carrera como entrenador.
          </h2>
        </div>

        <ol className="mt-14 border-l border-white/15 pl-6 sm:pl-10" data-id="element-168" data-mp="16dc54kmes8sz">
          {tomos.map(tomo => <li key={tomo.number} className="relative grid grid-cols-1 gap-1 py-6 sm:grid-cols-[13rem_1fr] sm:items-baseline sm:gap-8" data-id="element-169" data-mp="1bcorz5da5fvk">
              <span className="absolute -left-[calc(1.5rem+5px)] top-8 h-[9px] w-[9px] rounded-full bg-sunset ring-4 ring-ink sm:-left-[calc(2.5rem+5px)]" aria-hidden="true" data-id="element-170" data-mp="2mrc3vs9ipsen" />
              <h3 className="font-display text-xl font-bold text-white" data-id="element-171" data-mp="2mm3ukx5a7i1t">
                <span className="mr-2 text-sunset" data-id="element-172" data-mp="2mksmwm8ptq5f">Tomo {tomo.number}.</span>
                <span className="sm:block sm:mr-0" data-id="element-173" data-mp="2hlplrcvuw42q">{tomo.title}</span>
              </h3>
              <p className="text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-174" data-mp="2cnxric7qo5vd">
                {tomo.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}